// extracted by mini-css-extract-plugin
module.exports = {"sizeChart__nav":"styles_sizeChart__nav__jsUoj","sizeChart__button":"styles_sizeChart__button__S_lsB"};